import TEKTON_EXT_1 from "./TEKTON_EXT_1";
export default {
  TEKTON_EXT_1,
};
